import React from 'react';
import { AskBarIcon, AskBarInput, AskBarWrap } from './Analytics.styles';

export interface AnalyticsAskBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSubmit?: () => void;
  'aria-label'?: string;
}

/** CommandBar-style ask input for Analytics Center (sparkle, full width). */
const AnalyticsAskBar: React.FC<AnalyticsAskBarProps> = ({
  value,
  onChange,
  placeholder = 'Ask about tokens, sessions, or usage…',
  onSubmit,
  'aria-label': ariaLabel = 'Ask about analytics',
}) => (
  <AskBarWrap>
    <AskBarIcon aria-hidden="true">✨</AskBarIcon>
    <AskBarInput
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onSubmit?.();
        }
      }}
    />
  </AskBarWrap>
);

export default AnalyticsAskBar;
